import Marquee from "react-fast-marquee";

const ITEMS = [
  "550% Revenue Growth",
  "#1 Cannabis Brand — 2021 & 2022",
  "100% Client Retention",
  "47,000% Social Growth",
  "NFL / NBA / MLB / NHL / MLS Partnerships",
  "SXSW · Art Basel · Lollapalooza",
  "155,000+ Followers Built from Zero",
];

export default function StatsMarquee() {
  return (
    <section data-testid="marquee-stats" aria-label="Career highlights" className="marquee-wrap py-6 md:py-8">
      <Marquee gradient={false} speed={55} pauseOnHover>
        {ITEMS.map((t, i) => (
          <span key={i} className="font-anton uppercase text-5xl md:text-7xl lg:text-8xl px-8 md:px-12 flex items-center gap-8">
            {t}
            <span className="font-cormorant italic text-[#D83127] text-4xl md:text-6xl lg:text-7xl">+</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
